import { FC } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { useDispatch } from 'react-redux';
import type { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { setErrorStatusField } from 'redux/mainInfo/slice';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss';

type DatePickerProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDate: ActionCreatorWithPayload<Date | null | string>;
  date: Date | null;
  withoutHour?: boolean;
  nameError?: string;
};

export const DatePickerChoose: FC<DatePickerProps> = ({
  date,
  setDate,
  withoutHour,
  nameError,
}) => {
  const dispatch = useDispatch();

  const onChange = (date: Date | null) => {
    dispatch(setDate(date));
    if (nameError) {
      dispatch(setErrorStatusField({ key: nameError, value: 0 }));
    }
  };

  registerLocale('ru', ru);

  return (
    <DatePicker
      selected={date}
      onChange={onChange}
      inline
      locale={'ru'}
      timeInputLabel='Time:'
      dateFormat={withoutHour ? 'MM/dd/yyyy' : 'MM/dd/yyyy h:mm aa'}
      showTimeInput={!withoutHour}
      minDate={new Date()}
    />
  );
};
